import { mapGetters,mapMutations } from 'vuex';
const common={
    data() {
        return {   
           lang: window.location.href.indexOf("bluejeanimages") > 0 ? 1 : 0,
        }
    },
	computed:{
		...mapGetters([
		    'userInfo',
			'isRunLogin'
		]),
	},
	mounted(){
		
	},
    methods: {
		...mapMutations([
		    'setUserInfo',
			'setIsrunlogin'
		]),
    }
}
export default common;